import React, { useState, useEffect } from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';

const algorithmConfig = [
  { name: 'TrackMate', trainKey: 'TrackMate_Loss', valKey: 'TrackMate_Val', color: '#8884d8' },
  { name: 'uTrack', trainKey: 'uTrack_Loss', valKey: 'uTrack_Val', color: '#82ca9d' },
  { name: 'SPTNet', trainKey: 'SPTNet_Loss', valKey: 'SPTNet_Val', color: '#ff7300' },
  { name: 'DeepTrack', trainKey: 'DeepTrack_Loss', valKey: 'DeepTrack_Val', color: '#ffc658' },
  { name: 'BNP-Track', trainKey: 'BNPTrack_Loss', valKey: 'BNPTrack_Val', color: '#d62728' },
  { name: 'DeepTrack-NML', trainKey: 'DTNML_Loss', valKey: 'DTNML_Val', color: '#1f77b4' }
];

const TrainingChartCompare = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch('/compare_loss_data.json')
      .then((res) => res.json())
      .then((json) => setData(json))
      .catch((err) => console.error('Failed to load compare_loss_data.json:', err));
  }, []);

  if (!data || data.length === 0) return <div className="text-gray-500">📉 Loading comparison data...</div>;

  return (
    <div className="w-full h-[450px]">
      {/* <ResponsiveContainer width="100%" height="100%"> */}
        {/* <LineChart data={data}> */}
          {/* <CartesianGrid strokeDasharray="3 3" /> */}
          {/* <XAxis dataKey="name" /> */}
          {/* <YAxis label={{ value: 'Loss', angle: -90, position: 'insideLeft' }} /> */}
          {/* <Tooltip /> */}
          {/* <Legend /> */}

          {/* {algorithmConfig.map((algo) => ( */}
            {/* // <React.Fragment key={algo.name}> */}
              {/* <Line */}
                {/* // type="monotone" */}
                {/* // dataKey={algo.trainKey} */}
                {/* // stroke={algo.color} */}
                {/* // strokeWidth={2} */}
                {/* // name={`${algo.name} - Train`} */}
                {/* // dot={false} */}
              {/* // /> */}
              {/* <Line */}
                {/* // type="monotone" */}
                {/* // dataKey={algo.valKey} */}
                {/* // stroke={algo.color} */}
                {/* // strokeDasharray="5 2" */}
                {/* // strokeWidth={2} */}
                {/* // name={`${algo.name} - Val`} */}
                {/* // dot={false} */}
              {/* // /> */}
            {/* </React.Fragment> */}
          {/* // ))} */}
        {/* </LineChart> */}
      {/* </ResponsiveContainer> */}

      {/* 加上彩色线条 */}
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {algorithmConfig.map((algo) => (
            <Line
              key={`${algo.name}_train`}
              type="monotone"
              dataKey={algo.trainKey}
              stroke={algo.color}
              strokeDasharray="5 5"
              name={`${algo.name} Train`}
            />
          ))}
          {algorithmConfig.map((algo) => (
            <Line
              key={`${algo.name}_val`}
              type="monotone"
              dataKey={algo.valKey}
              stroke={algo.color}
              strokeWidth={2}
              name={`${algo.name} Val`}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TrainingChartCompare;
